import React from 'react';

const definition = (props) => {
  return (
    <div className="AS-definition padding-top-bottom-sm padding-left-right-md">
      {props.definition}
    </div>
  )
}

export default definition;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/list/Definition.js